import React from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import './GearTrackerCreate.css';



function GearTrackerCreate() {

    const navigate = useNavigate();

    async function createStatic(event) {
        event.preventDefault();
        console.log("creating static")
        var data = new FormData(event.target)
        let url = process.env.REACT_APP_API_URL + '/gearing/create'
        try {
            await axios.post(url, {
                data: {
                    name: data.get('staticName'),
                    count: 8
                }
            }).then(response => {
                navigate('/gearing/' + response.data.staticID)
            })
        }
        catch (err) {
            console.log(err)
        }
    }


    return (
        <div style={{ fontFamily: 'Noto Sans', display: 'flex', justifyContent: 'center' }}>
            <div style={{ marginTop: '30vh' }}>
                <div style={{ fontSize: '64px', textAlign: 'center', marginBottom: '50px' }}>Create a static</div>
                <form onSubmit={createStatic} id="staticForm" autoComplete='off'>
                    <div>
                        <TextField
                            id="staticName" label="static name:" variant="standard" type="text" name="staticName"
                            sx={{ input: { color: 'aliceblue', borderBottom: "2px solid #ffffff", textAlign: 'center', fontSize: '24px' }, label: { color: 'aliceblue' }, width: '128ch' }}
                            slotProps={{ htmlInput: { maxLength: 64 } }}
                        />
                    </div>
                    <div className='btn-container' style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}><Button className='create' variant="contained" id="submit" color="primary" type="submit">Create Static</Button> </div>
                </form>
            </div>
        </div>
    );
}

export default GearTrackerCreate;